import { Box, TextButton } from '@wix/design-system'
import { ChevronLeft } from '@wix/wix-ui-icons-common'
import React, { FC } from 'react'

import { ErrorNotificationOutlet } from '../../../components/ErrorNotification/ErrorNotificationOutlet'
import WixStudioLogo from '../icons/WixStudioLogo.svg'
import { dataHooks } from './WixStudioMobileHeader.dataHooks'
import s from './WixStudioMobileHeader.scss'

type Props = {
  skip?: string
  onSkipClick?: () => void
  onBackClick?: () => void
  dataHook?: string
}
export const WixStudioMobileHeader: FC<Props> = ({ skip, onSkipClick, dataHook, onBackClick }) => {
  return (
    <>
      <Box
        width="100%"
        boxShadow="0 8px 14px 0 rgba(0, 0, 0, 0.04)"
        height="54px"
        padding="18px"
        verticalAlign="middle"
        boxSizing="border-box"
        dataHook={dataHook}
      >
        {onBackClick && (
          <>
            <TextButton skin="dark" onClick={onBackClick} prefixIcon={<ChevronLeft />} />
            <div className={s.backDivider} />
          </>
        )}
        <WixStudioLogo width="112.2px" style={{ marginRight: 'auto' }} />
        {skip && (
          <TextButton size="small" onClick={onSkipClick} skin="dark" dataHook={dataHooks.skip()}>
            {skip}
          </TextButton>
        )}
      </Box>
      <ErrorNotificationOutlet />
    </>
  )
}
